import React, { useState, useEffect, useRef } from 'react';
import { Input } from './ui/input';
import { ScrollArea } from './ui/scroll-area';

const ClienteAutocomplete = ({ clientes, value, onChange, ...props }) => {
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [inputValue, setInputValue] = useState(value || '');
  const wrapperRef = useRef(null);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    onChange(val);

    if (val.length > 0) {
      const filtered = clientes.filter((cliente) =>
        cliente.name.toLowerCase().includes(val.toLowerCase())
      );
      setFilteredClientes(filtered);
      setShowSuggestions(true);
    } else {
      setFilteredClientes([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectCliente = (clienteName) => {
    setInputValue(clienteName);
    onChange(clienteName);
    setShowSuggestions(false);
  };

  return (
    <div ref={wrapperRef} className="relative">
      <Input
        {...props}
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => {
          if (inputValue.length > 0 && filteredClientes.length > 0) {
            setShowSuggestions(true);
          }
        }}
      />
      {showSuggestions && filteredClientes.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg">
          <ScrollArea className="max-h-60">
            {filteredClientes.map((cliente) => (
              <div
                key={cliente.id}
                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                onClick={() => handleSelectCliente(cliente.name)}
              >
                {cliente.name}
              </div>
            ))}
          </ScrollArea>
        </div>
      )}
    </div>
  );
};

export default ClienteAutocomplete;
